import { type SVGProps } from 'react';

import { cn } from '@shared/utils';

export interface SearchClearIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function SearchClearIcon({ className, ...props }: Readonly<SearchClearIconProps>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
      aria-hidden="true"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5ZM6.85355 6.14645C6.65829 5.95118 6.34171 5.95118 6.14645 6.14645C5.95118 6.34171 5.95118 6.65829 6.14645 6.85355L7.29289 8L6.14645 9.14645C5.95118 9.34171 5.95118 9.65829 6.14645 9.85355C6.34171 10.0488 6.65829 10.0488 6.85355 9.85355L8 8.70711L9.14645 9.85355C9.34171 10.0488 9.65829 10.0488 9.85355 9.85355C10.0488 9.65829 10.0488 9.34171 9.85355 9.14645L8.70711 8L9.85355 6.85355C10.0488 6.65829 10.0488 6.34171 9.85355 6.14645C9.65829 5.95118 9.34171 5.95118 9.14645 6.14645L8 7.29289L6.85355 6.14645Z"
        fill="#A4A7AE"
      />
    </svg>
  );
}
